module.exports = __webpack_public_path__ + "img/futureWill3.fae555ce.png";